module.exports = "https://bin.bnbstatic.com/_next/static/images/app-home-f4652c7914e8c33e6d2e8bed2824649c.png";